import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { API } from "../../utils/axios";

export default function BusinessRegistrationSuccess() {
  const [timer, setTimer] = useState(60);
  const [searchParams] = useSearchParams()
  const email= searchParams.get("email")

  const resendVerificationLink = async () => {
    if(!email){
      toast.error("Server Error. Please try again")
    }
    try {
      const { data } = await API.post("/business/resend-verification-email",
        { email }
      );
      setTimer(60)
      toast.success(data.message);
    } catch (err) {
      console.log(err);
    } 
  };

  useEffect(() => {
    let countdown: any;

    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(countdown);
  }, [timer]);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-17685944295/2yFlCOzW370bE0evqPFB",
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 flex flex-col">
      <section className="flex-1 flex flex-col justify-center items-center text-center px-6 pb-60 bg-gradient-to-b from-white to-blue-100">
        <div className="w-full max-w-2xl bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 sm:p-8 transform transition-all duration-300 scale-100 hover:scale-[1.01] flex flex-col items-center text-center space-y-4">
          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            Thank you for joining LastMinuteWellness!
          </p>
          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            Your form is submitted successfully 
          </p>
          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            A verification email has been sent to your inbox.
            <br />
            Please check your email and verify your account to continue.
          </p>
          {/* <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400 mb-8">
            If you have any questions in the meantime, feel free to reach out at{" "}
            <a
              href="mailto:info@lastminutewellness.ca"
              className="text-blue-600 underline"
            >
              info@lastminutewellness.ca
            </a>
          </p> */}
          <div className="mt-10">
          {timer > 0 ? (
            <p className="text-gray-500 text-sm">
              Resend verification email will be active in{" "}
              <span className="font-semibold">{timer}</span> seconds.
            </p>
          ) : (
            <button
              onClick={resendVerificationLink}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow transition-all"
            >
              Resend Verification Email
            </button>
          )}
        </div>
        </div>

      </section>
    </div>
  );
}
